import { _ as _objectWithoutPropertiesLoose, a as _objectSpread2 } from "./auth-service-tools630.js";
import { createComponent } from "./auth-service-tools631.js";
import { createHook } from "./auth-service-tools637.js";
import "react";
import { usePopoverArrow } from "./auth-service-tools148.js";
import { a as TOOLTIP_ARROW_KEYS } from "./auth-service-tools698.js";
var useTooltipArrow = createHook({
  name: "TooltipArrow",
  compose: usePopoverArrow,
  keys: TOOLTIP_ARROW_KEYS,
  useOptions: function useOptions(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 16 : _ref$size,
        options = _objectWithoutPropertiesLoose(_ref, ["size"]);

    return _objectSpread2({
      size
    }, options);
  }
});
var TooltipArrow = createComponent({
  as: "div",
  memo: true,
  useHook: useTooltipArrow
});
export { TooltipArrow, useTooltipArrow };